import React from 'react'
import { TextField } from '@material-ui/core'

export  const TxtField = (props)=>{
    console.log("TxtField",props)
    return(
        <TextField {...props} />
    )
}
